import ModelUtil from '@leverege/model-util';
import { createImagineAggregationBuilder } from "../AggregationBuilder.js";
const imagineType = 'geoDistance';
const TYPE = `aggregation.${imagineType}`;
const methods = {
  ...ModelUtil.createAllValue('field'),
  ...ModelUtil.createAllArray('ranges'),
  ...ModelUtil.createAllValue('origin/lat', 'originLat'),
  ...ModelUtil.createAllValue('origin/lon', 'originLon'),
  ...ModelUtil.createAllValue('origin', 'origin'),
  ...ModelUtil.createAllValue('unit'),
  ...ModelUtil.createAllValue('distanceType'),
  ...ModelUtil.createAllValue('keyed'),
  ...ModelUtil.createAllValue('attrName')
};
function create() {
  return {
    type: TYPE,
    field: null,
    ranges: [],
    origin: {
      lat: null,
      lon: null
    },
    unit: 'km',
    distanceType: 'plane',
    keyed: false,
    attrName: null
  };
}
function getValueType(model) {
  return 'geoDistance';
}
function formatBucketKey(bucket, value) {
  const fromLabel = `${bucket.from == null ? '*' : bucket.from}${value.unit}`;
  const toLabel = `${bucket.to == null ? '*' : bucket.to}${value.unit}`;
  return `${fromLabel} - ${toLabel}`;
}
export default {
  create,
  TYPE,
  name: 'Geo Distance',
  ...methods,
  toImagineAgg: createImagineAggregationBuilder(imagineType),
  getValueType,
  formatBucketKey
};